import { render, staticRenderFns } from "./item.vue?vue&type=template&id=5c3d2b64&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3d2b64')) {
      api.createRecord('5c3d2b64', component.options)
    } else {
      api.reload('5c3d2b64', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=5c3d2b64&", function () {
      api.rerender('5c3d2b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/statistics/item.vue"
export default component.exports